import React from 'react';
import { ArrowRight, CreditCard } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';
export function Hero() {
  const {
    language
  } = useLanguage();
  const t = translations[language].hero;
  const scrollToCalculator = () => {
    const element = document.getElementById('calculator');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <section id="hero" className="bg-gradient-to-b from-gray-50 to-white py-16 sm:py-24" data-id="element-112">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-113">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-114">
          <div data-id="element-115">
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight" data-id="element-116">
              {t.title}
            </h1>
            <p className="mt-6 text-lg sm:text-xl text-gray-600 leading-relaxed" data-id="element-117">
              {t.subtitle}
            </p>
            <button onClick={scrollToCalculator} className="mt-8 inline-flex items-center gap-2 bg-gray-900 text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-gray-800 transition-colors" data-id="element-118">
              {t.cta}
              <ArrowRight className="w-5 h-5" data-id="element-119" />
            </button>
          </div>

          <div className="relative" data-id="element-120">
            <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-200" data-id="element-121">
              <div className="flex items-center gap-3 mb-6" data-id="element-122">
                <div className="w-10 h-10 bg-gray-900 rounded-lg flex items-center justify-center" data-id="element-123">
                  <CreditCard className="w-6 h-6 text-white" data-id="element-124" />
                </div>
                <div data-id="element-125">
                  <div className="text-sm text-gray-500" data-id="element-126">{t.paymentAmount}</div>
                  <div className="text-2xl font-bold text-gray-900" data-id="element-127">50 EUR</div>
                </div>
              </div>

              <div className="space-y-3" data-id="element-128">
                <div className="flex items-center justify-between p-4 bg-blue-50 border-2 border-blue-500 rounded-lg" data-id="element-129">
                  <div data-id="element-130">
                    <div className="font-semibold text-gray-900" data-id="element-131">Wave</div>
                    <div className="text-sm text-gray-600" data-id="element-132">33,784 XOF</div>
                  </div>
                  <div className="bg-blue-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-133">
                    {t.best}
                  </div>
                </div>

                <div className="flex items-center justify-between p-4 bg-emerald-50 border border-emerald-200 rounded-lg" data-id="element-134">
                  <div data-id="element-135">
                    <div className="font-semibold text-gray-900" data-id="element-136">Djamo</div>
                    <div className="text-sm text-gray-600" data-id="element-137">34,100 XOF</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative elements */}
            <div className="absolute -top-4 -right-4 w-24 h-24 bg-blue-100 rounded-full blur-2xl opacity-50" data-id="element-138" />
            <div className="absolute -bottom-4 -left-4 w-32 h-32 bg-emerald-100 rounded-full blur-2xl opacity-50" data-id="element-139" />
          </div>
        </div>
      </div>
    </section>;
}